import { motion } from "framer-motion";
import SubscribeForm from "../components/SubscribeForm";

function CenterContent({ className = "" }) {
  return (
    <main className={`flex flex-col items-center justify-center px-6 py-24 md:py-6 grow ${className}`}>
      <h1 
        className="text-[48px] lg:text-[68px] xl:text-[84px] leading-none"
      >
        {"CLEARANCE".split("").map((letter, i) => (
          <motion.span
            key={i}
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.3, 0, 0.7, 0, 1] }}
            transition={{ 
              duration: 0.6, 
              delay: 0.5 + i * 0.05,
              times: [0, 0.2, 0.3, 0.5, 0.6, 1],
              ease: "easeInOut"
            }}
          >
            {letter}
          </motion.span>
        ))}
      </h1>
      <h2 
        className="text-[48px] lg:text-[68px] xl:text-[84px] leading-none mb-6"
      >
        {"PENDING...".split("").map((letter, i) => (
          <motion.span
            key={i}
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.4, 0, 0.8, 0, 1] }}
            transition={{ 
              duration: 0.7, 
              delay: 0.9 + i * 0.04,
              times: [0, 0.15, 0.25, 0.45, 0.55, 1],
              ease: "easeInOut"
            }}
          >
            {letter}
          </motion.span>
        ))}
      </h2>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.7, ease: "easeOut" }}
      >
        <SubscribeForm />
      </motion.div>
    </main>
  );
}

export default CenterContent;